import React, { Component } from "react";
import { AccountState, VehicleState } from "Types/state";
import FlyoutGarageEmpty from "./FlyoutGarageEmpty";
import FlyoutList from "./FlyoutList";

interface FlyoutGarageProps {
    account: AccountState;
    uuid: string;
    env: string;
    isAuthed: boolean;
    signIn: () => void;
    toggleOSModal: (slug: string, env: string, uuid: string) => void;
    vehicles: VehicleState[];
}

export class FlyoutGarage extends Component<FlyoutGarageProps> {
    public render() {
        const { account, isAuthed, signIn, toggleOSModal, vehicles, env, uuid } = this.props;

        return isAuthed && vehicles && vehicles.length ? (
            <FlyoutList
                account={account}
                vehicles={vehicles}
                isAuthed={isAuthed}
                onViewGarage={() => toggleOSModal(account.slug, env, uuid)}
            />
        ) : (
            <FlyoutGarageEmpty isAuthed={isAuthed} onSignIn={signIn} />
        );
    }
}
